import { render, staticRenderFns } from "./AttendanceSummaryTable.vue?vue&type=template&id=31046f56&scoped=true&"
import script from "./AttendanceSummaryTable.vue?vue&type=script&lang=js&"
export * from "./AttendanceSummaryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31046f56",
  null
  
)

export default component.exports